import {
  SCORE_TYPE_OPTIONS,
  VIEW_BY_KEYS,
} from '@edulastic/constants/reportUtils/dataWarehouseReports/domainAnalysisReport/constants'

export {
  ANALYZE_BY_KEYS,
  ANALYZE_BY_OPTIONS,
  CHART_PAGE_SIZE,
  CSV_FILENAME,
  groupInfoMap,
  LAMBDA_PAGE_SIZE,
  NEXT_VIEW_BY_KEYS,
  reportAtOptions,
  SCORE_TYPE_KEYS,
  SCORE_TYPE_OPTIONS,
  TABLE_PAGE_SIZE,
  VIEW_BY_KEYS,
  VIEW_BY_OPTIONS,
} from '@edulastic/constants/reportUtils/dataWarehouseReports/domainAnalysisReport/constants'

export const SORT_BY_KEYS = {
  DIMENSION: 'dimension',
  ASSESSMENT_: 'ASSESSMENT_',
}

export const DEFAULT_FILTERS = {
  // student filters
  termId: '',
  districtIds: [],
  networkIds: [],
  schoolIds: [],
  teacherIds: [],
  grades: [],
  subjects: [],
  courseId: '',
  classIds: [],
  groupIds: [],
  // test filters
  testTermIds: [],
  testGrades: [],
  testSubjects: [],
  assessmentTypes: [],
  tagIds: [],
  testUniqIds: [],
  // demographic filters
  race: '',
  gender: '',
  iepStatus: '',
  frlStatus: '',
  ellStatus: '',
  hispanicEthnicity: '',
  // page filters
  reportAt: VIEW_BY_KEYS.DOMAIN,
  scoreType: SCORE_TYPE_OPTIONS[0].key,
  curriculumId: '',
  standardGrades: [],
  domainIds: [],
  clusterIds: [],
  standardIds: [],
}

export const SKILL_INFO_FILTERS = [
  // student filters
  'termId',
  'districtIds',
  'schoolIds',
  'teacherIds',
  'grades',
  'subjects',
  'courseId',
  'classIds',
  'groupIds',
  // test filters
  'testTermIds',
  'assessmentTypes',
  'testUniqIds',
]

// page standard filters are reset when any of the SKILL_INFO_FILTERS are changed.
// ref: https://github.com/snapwiz/edulastic-poc/blob/f6780d55d77f60ee213fe2fd399226ddfb8cb190/src/client/author/Reports/subPages/dataWarehouseReports/DomainAnalysis/components/PopupFilters.js#L292
export const PAGE_STANDARD_FILTERS = [
  'curriculumId',
  'domainIds',
  'clusterIds',
  'standardIds',
]

export const STANDARD_HIERARCHY_FIELD_KEYS = [
  'domainId',
  'clusterId',
  'standardId',
]

export const HIERARCHY_KEYS_BY_REPORT_AT = {
  [VIEW_BY_KEYS.DOMAIN]: STANDARD_HIERARCHY_FIELD_KEYS.slice(0, 1),
  [VIEW_BY_KEYS.CLUSTER]: STANDARD_HIERARCHY_FIELD_KEYS.slice(0, 2),
  [VIEW_BY_KEYS.STANDARD]: STANDARD_HIERARCHY_FIELD_KEYS,
}
